import { render, staticRenderFns } from "./LocalizationsField.vue?vue&type=template&id=c86cb18a&"
import script from "./LocalizationsField.vue?vue&type=script&lang=js&"
export * from "./LocalizationsField.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationsField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports